module.exports = __webpack_public_path__ + "static/img/news6_2.86df84e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsDetail/images/news6_2.jpg
// module id = Ak++
// module chunks = 0